module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames4-16aba409814e4a09dca962771061d382.png";